import { Component, inject, Input, OnInit } from '@angular/core';
import { ApiService } from '@core/providers/http';
import { ConfirmationService } from 'primeng/api';
import {
  EnumService,
  InstituicaoEnsinoService,
  UnidadeOrganicaService,
} from '../../../api/services';
import { TableComponent } from '@app/shared/components/table/table.component';
import { TableColumn } from '@shared/components/table/table.component';
import { Pagination } from '../../../../../../shared/model/pagination.model';
import { MenuItem, MessageService } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { DialogService } from 'primeng/dynamicdialog';
import { UnidadeOrganicaComponent } from '../unidade-organica/unidade-organica.component';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { forkJoin } from 'rxjs';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { AuthStore } from '@core/service/auth-store.service';

@Component({
  selector: 'app-unidade-organica-list',
  imports: [
    TableComponent,
    CommonModule,
    ReactiveFormsModule,
    UnidadeOrganicaComponent,
    DataVoidComponent,
    SearchBarComponent,
    ToastModule,
    ConfirmDialogModule,
  ],
  providers: [
    ApiService,
    UnidadeOrganicaService,
    DialogService,
    EnumService,
    InstituicaoEnsinoService,
    ConfirmationService,
  ],
  templateUrl: './unidade-organica-list.component.html',
  styleUrl: './unidade-organica-list.component.scss',
})
export class UnidadeOrganicaListComponent implements OnInit {
  pagination: Pagination<any> = new Pagination<any>();
  dialogService = inject(DialogService);
  @Input() insituicaoEnsinoID!: string;
  private auth = inject(AuthStore);
  unidadeOrganicaService = inject(UnidadeOrganicaService);
  confirmationService = inject(ConfirmationService);
  messageService = inject(MessageService);
  naturezaOptions: any[] = [];
  typeofEducationalInstitution: any[] = [];
  enumService = inject(EnumService);
  actions: MenuItem[] = [
    {
      label: 'Editar',
      icon: 'pi pi-pencil',
      command: ($event: any) => this.callRouteEditBolsa($event.item?.data),
    },
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      command: ($event: any) => this.confirmDelete($event.item?.data),
    },
    // {
    //   label: 'Eliminar',
    //   icon: 'pi pi-trash',
    //   command: ($event: any) => this.deleteUnidadeOrganica($event.item?.data),
    // },
  ];
  instituicaoEnsinoService = inject(InstituicaoEnsinoService);
  columns: TableColumn[] = [
    { field: 'nome', header: 'Nome', type: 'text', tooltip: 'Nome da Unidade' },
    {
      field: 'sigla',
      header: 'Sigla',
      type: 'text',
      tooltip: 'Sigla da Unidade',
    },
    {
      field: 'email',
      header: 'Email',
      type: 'text',
      tooltip: 'Email da Unidade',
    },
    {
      field: 'telefone',
      header: 'Numero de Telefone',
      type: 'text',
      tooltip: 'Telefone da Unidade',
    },
    {
      field: 'pais',
      header: 'Pais',
      type: 'text',
      tooltip: 'Pais da Unidade',
    },
  ];

  ngOnInit(): void {
    this.loadAllUnidadeOrganica();
    this.loadEnums();
  }

  CreateOrgUnit(instituicaoEnsinoId?: string): void {
    const ref = this.dialogService.open(UnidadeOrganicaComponent, {
      header: 'Adicionar Unidade Orgânica',
      width: '40%',
      showHeader: false,
      modal: true,
      data: {
        instituicaoEnsinoId: instituicaoEnsinoId,
        typeofEducationalInstitution: this.typeofEducationalInstitution,
        naturezaOptions: this.naturezaOptions,
      },
    });

    ref.onClose.subscribe((result) => {
      if (result) {
        this.messageService.add(result);
        this.loadAllUnidadeOrganica();
      }
    });
    // this.router.navigate([
    //   `/gestao-bolseiros/instituicao-ensino/add-representante/${instituicaoEnsinoId}`,
    // ]);
  }

  loadAllUnidadeOrganica() {
    this.instituicaoEnsinoService
      .list({ InstituicaoPaiID: this.insituicaoEnsinoID })
      .subscribe((res) => {
        this.pagination = res;
      });
  }

  onActionSelected(event: any) {
    const { event: actionEvent, rowData } = event;
    this.actions
      .find((action) => action.label === actionEvent.item.label)
      ?.command?.({ item: rowData });
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page;
    this.pagination.pageSize = event.rows;
    this.loadAllUnidadeOrganica();
  }

  callRouteEditBolsa(data: any) {
    this.dialogService.open(UnidadeOrganicaComponent, {
      header: 'Editar Unidade Orgânica',
      width: '40%',
      showHeader: false,
      modal: true,
      data: {
        instituicaoEnsinoId: this.insituicaoEnsinoID,
        unidadeOrganica: data,
        typeofEducationalInstitution: this.typeofEducationalInstitution,
        naturezaOptions: this.naturezaOptions,
      },
    });
  }

  loadEnums() {
    forkJoin({
      naturezaInstituicao: this.enumService.getAllNaturezaInstituicaoEnum(),
      tipoInstituicao: this.enumService.getAllTipoInstituicaoEnum(),
    }).subscribe((response: any) => {
      if (response.naturezaInstituicao?.data) {
        this.naturezaOptions = Object.entries(
          response.naturezaInstituicao.data
        ).map(([key, value]) => ({
          id: Number(key),
          designacao: value,
        }));
      }

      if (response.tipoInstituicao?.data) {
        this.typeofEducationalInstitution = Object.entries(
          response.tipoInstituicao.data
        ).map(([key, value]) => ({
          id: Number(key),
          designacao: value,
        }));
      }
    });
  }

  deleteUnidadeOrganica(data: any): void {
    this.instituicaoEnsinoService.delete(data.id).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: `Unidade Orgânica "${data.nome}" eliminada com sucesso.`,
          life: 3000,
        });
        this.loadAllUnidadeOrganica();
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: `Erro ao eliminar a Unidade Orgânica "${data.nome}".`,
          life: 3000,
        });
        console.error('Erro ao eliminar Unidade Orgânica:', err);
      },
    });
  }

  confirmDelete(data: any): void {
    this.confirmationService.confirm({
      message: `Tens a certeza que desejas eliminar a Unidade Orgânica <strong>${data.nome}</strong>?`,
      header: 'Confirmar Eliminação',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => this.deleteUnidadeOrganica(data),
    });
  }
}
